import { createContext } from 'react';
import {
  AgentLogStatus,
  OperationSystemSessionState,
  RealTimeLogViewModel,
  StepLogModel,
} from '../model/dashboard.model';
import { DepartamentsModel } from 'app/departaments/model/departaments.model';

interface DashboardContextValue {
  getStepLog(): void;
  stepLogIsLoading: boolean;
  filteredGroupedRobots: GroupedRobots[];
  dashboardFilters: DashboardFilters;
  UpdateSingleItemStatusOnList(status: AgentLogStatus, eventId: number): void;
  UpdateMachineStatusOnList(machineName: string, sessionState: OperationSystemSessionState): void;
  UpdateMachineConnectionOnList(machineName: string, isUp: boolean): void;
  UpdateEventProgress(
    eventId: number,
    stepId: number | undefined,
    status: AgentLogStatus,
    realTimeLog?: RealTimeLogViewModel,
  ): void;
  setFilter(filters: DashboardFilters): void;
  filtered: boolean;
}

const DashboardContext = createContext<DashboardContextValue>({
  getStepLog: () => {},
  stepLogIsLoading: false,
  filteredGroupedRobots: [],
  dashboardFilters: {},
  UpdateSingleItemStatusOnList: (status: AgentLogStatus, eventId: number) => {},
  UpdateMachineStatusOnList: (machineName: string, sessionState: OperationSystemSessionState) => {},
  UpdateMachineConnectionOnList: (machineName: string, isUp: boolean) => {},
  UpdateEventProgress: (
    eventId: number,
    stepId: number | undefined,
    status: AgentLogStatus,
    realTimeLog?: RealTimeLogViewModel,
  ) => {},
  setFilter: (filters: DashboardFilters) => {},
  filtered: false,
});

export interface GroupedRobots {
  key: string;
  events: StepLogModel[];
}

export interface DashboardFilters {
  status?: AgentLogStatus;
  department?: DepartamentsModel;
}

export default DashboardContext;
